export default "__VITE_ASSET__C6rQKHp9__"